import { 
  useEffect,
  useState
}                from 'react';
import PropTypes from 'prop-types';
import { 
  Dimmer,
  Loader
}                from 'semantic-ui-react';
import cns       from 'classnames';
import styles    from './ui-loader.module.scss';

const UILoaderDelay = ({ delay }) => {
  let timeout;
  const [ visible, setVisible ] = useState(false);

  useEffect(() => {
    timeout = setTimeout(() => {setVisible(true)}, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <If condition={visible}>
      <Dimmer active={true} inverted>
        <Loader size="small" inverted/>
      </Dimmer>
    </If>
  )
};

const UILoader = ({ active, type, delay }) => {
  return (
    <If condition={active}>
      <div className={cns(styles.component, {
        [styles.local]: type === 'local',
        [styles.global]: type === 'global'
      })}>
        <UILoaderDelay delay={delay}/>
      </div>
    </If>
  )
};

UILoader.propTypes = {
  active: PropTypes.bool,
  type:   PropTypes.oneOf(['local', 'global'])
};

UILoader.defaultProps = {
  active: false,
  type: 'local',
  delay: 1500
};

export default UILoader;